<template>
  <div>
    <b-row>
      <b-col md="4">
        <v-select
          v-model="activeBranch"
          label="nameEn"
          placeholder="Select Branch"
          :options="branches"
          :loading="fetchingDetails"
          @input="changeBranchHandler"
        />
      </b-col>
      <b-col
        md="2"
        class="mb-2"
      >
        <b-button
          variant="primary"
          :disabled="fetchingDetails"
          @click="fetch"
        >
          Refresh Branches
        </b-button>
      </b-col>
      <b-col
        v-if="activeBranch"
        md="12"
      >
        <b-card>
          <b-row
            v-if="displayPromoForm"
            class="mb-2"
          >
            <b-col md="4">
              <b-form-input
                v-model.trim="codeName"
                placeholder="Enter code here"
              />
            </b-col>
            <b-col md="4">
              <b-button
                variant="primary"
                :disabled="!codeName || savingPromo"
                @click="savePromo"
              >
                Save promo
              </b-button>
            </b-col>
            <b-col
              md="4"
              class="d-flex justify-content-end"
            >
              <b-button
                size="sm"
                variant="flat-primary"
                @click="displayPromoForm = false;codeName = ''"
              >
                <feather-icon
                  icon="XIcon"
                  size="24"
                />
              </b-button>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-between align-items-center">
            <h3>Promos for {{ activeBranch.name.en }}</h3>
            <b-button
              v-if="!displayPromoForm && promos.length"
              variant="primary"
              :disabled="savingPromo"
              @click="savePromo"
            >
              Save Changes
            </b-button>
            <b-button
              v-if="!displayPromoForm"
              variant="primary"
              @click="displayPromoForm = true"
            >
              Create new promo
            </b-button>
          </div>
          <div v-if="!promos.length">
            No promos for this branch yet
          </div>
          <template v-else>
            <div class="d-flex align-items-center my-1 flex-wrap">
              <div
                v-for="(promo, ix) in promos"
                :key="ix"
                class="d-flex align-items-center mr-3"
              >
                <b-form-input
                  v-if="promo.edit"
                  :id="`${ix}`"
                  v-model.trim="promo.code"
                />
                <h4 v-else>
                  &#8226; {{ promo.code }}
                </h4>
                <b-button
                  class="btn-icon rounded-circle"
                  variant="flat-danger"
                  @click="removePromo(ix)"
                >
                  <feather-icon
                    size="16"
                    icon="TrashIcon"
                  />

                </b-button>
                <b-button
                  class="btn-icon rounded-circle"
                  variant="flat-primary"
                  @click="promo.edit = !promo.edit"
                >
                  <span v-if="promo.edit">Done</span>
                  <feather-icon
                    v-else
                    size="16"
                    icon="EditIcon"
                  />
                </b-button>
              </div>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  BRow, BCol, BCard, BButton, BFormInput,
} from 'bootstrap-vue'
import sleep from '@/utils/sleep'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    vSelect, BRow, BCol, BCard, BButton, BFormInput,
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const fetchingDetails = ref(false)
    const displayPromoForm = ref(false)
    const activeBranch = ref()
    const branches = ref([])
    const promos = ref([])
    const fetch = async () => {
      fetchingDetails.value = true
      const res = await ctx.root.$store.dispatch(
        'business/getBusinessDetails',
        {
          businessId,
        },
      )
      const { data } = res.data.data
      branches.value = data.branches.map(b => ({
        ...b,
        nameEn: b.name.en,
        nameAr: b.name.ar,
      }))
      if (activeBranch.value) {
        const currViewedBranch = branches.value.find(b => b.id === activeBranch.value.id)
        activeBranch.value = currViewedBranch
      } else {
        const firstBranch = branches.value[0]
        activeBranch.value = firstBranch
      }
      promos.value = activeBranch.value.promos.map(p => ({
        ...p,
        edit: false,
      }))
      fetchingDetails.value = false
    }
    fetch()

    const changeBranchHandler = () => {
      promos.value = activeBranch.value.promos.map(p => ({
        ...p,
        edit: false,
      }))
    }

    const removePromo = ix => {
      promos.value.splice(ix, 1)
    }

    const codeName = ref('')
    const savingPromo = ref(false)
    const savePromo = async () => {
      const promosTemp = promos.value.map(p => ({ code: p.code }))
      if (codeName.value) {
        const isFound = promos.value.find(p => p.code.toLowerCase() === codeName.value.toLowerCase())
        if (isFound) {
          errorNotification('Code already exists')
          return
        }
        promosTemp.push({ code: codeName.value })
      }
      savingPromo.value = true
      await ctx.root.$store.dispatch('business/updateBusinessBranch', {
        businessId,
        branchId: activeBranch.value.id,
        data: {
          config: {
            fixedLocations: activeBranch.value.fixedLocations,
            promos: promosTemp,
          },
        },
      })
      await sleep(1000)
      if (codeName.value) {
        codeName.value = ''
      }
      displayPromoForm.value = false
      savingPromo.value = false
      fetch()
    }

    return {
      fetch,
      activeBranch,
      removePromo,
      promos,
      displayPromoForm,
      fetchingDetails,
      savePromo,
      savingPromo,
      branches,
      changeBranchHandler,
      codeName,
    }
  },

}
</script>
